import React, { ReactNode, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import styled from 'styled-components';
import appStoreLogo from '../assets/app-store.png';
import googlePlayLogo from '../assets/google-play.png';
import cardLogo from '../assets/footer-card.png';
import paramLogo from '../assets/param-logo.jpeg';
import { Home, PenTool, BookOpen, CircleDollarSign, MessageSquare, Clock, Send, Ticket, User, HelpCircle, Mail, LogOut, LayoutGrid } from 'lucide-react';


// Social Media SVG Icons
const getSocialIconSvg = (type: string) => {
  const iconMap = {
    'facebook': (
      <svg width="16" height="16" fill="currentColor" viewBox="0 0 24 24">
        <path fill="currentColor" d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
      </svg>
    ),
    'twitter': (
      <svg width="16" height="16" fill="currentColor" viewBox="0 0 24 24">
        <path fill="currentColor" d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z" />
      </svg>
    ),
    'instagram': (
      <svg width="16" height="16" fill="currentColor" viewBox="0 0 24 24">
        <path fill="currentColor" d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
      </svg>
    ),
    'tiktok': (
      <svg width="16" height="16" fill="currentColor" viewBox="0 0 24 24">
        <path fill="currentColor" d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z" />
      </svg>
    )
  };
  return iconMap[type as keyof typeof iconMap] || iconMap.facebook;
};

interface LayoutProps {
  children: ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  
  const isApp = !!(window as any).ReactNativeWebView;
  const [expandedSections, setExpandedSections] = useState<string[]>([]);

  const toggleSection = (section: string) => {
    if (window.innerWidth > 768) return;
    setExpandedSections(prev => 
      prev.includes(section) ? prev.filter(s => s !== section) : [...prev, section]
    );
  };

  // Sidebar açıkken body scroll'u engelle (iOS uyumlu)
  React.useEffect(() => {
    const scrollY = window.scrollY;
    
    if (sidebarOpen) {
      // Kilitleme
      document.body.style.setProperty('position', 'fixed', 'important');
      document.body.style.setProperty('top', `-${scrollY}px`, 'important');
      document.body.style.setProperty('width', '100%', 'important');
      document.body.style.setProperty('overflow', 'hidden', 'important');
      document.body.style.setProperty('touch-action', 'none', 'important');
      
      // Menüye scroll hakkı tanı
      const sidebarContent = document.getElementById('sidebar-content');
      if (sidebarContent) {
        sidebarContent.style.touchAction = 'pan-y';
      }
    } else {
      // Geri yükleme
      const savedScrollY = parseInt(document.body.style.top || '0') * -1;
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      document.body.style.overflow = '';
      document.body.style.touchAction = '';
      
      if (savedScrollY > 0) {
        window.scrollTo(0, savedScrollY);
      }
    }
    
    return () => {
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      document.body.style.overflow = '';
      document.body.style.touchAction = '';
    };
  }, [sidebarOpen]);

  const handleLogout = () => {
    navigate('/');
    setTimeout(() => {
      logout();
    }, 100);
  };

  return (
    <Container>
      <Header>
        <HeaderLeft>
          <MenuButton 
            onClick={() => {
              if ((window as any).triggerHaptic) (window as any).triggerHaptic('light');
              setSidebarOpen(!sidebarOpen);
            }}
            aria-label="Menüyü aç"
            aria-expanded={sidebarOpen}
          >
            ☰
          </MenuButton>
          <Logo 
            onClick={() => navigate('/')} 
            role="button" 
            tabIndex={0} 
            aria-label="Postacım Anasayfa"
            onKeyDown={(e) => e.key === 'Enter' && navigate('/')}
          >
            <LogoImage src="/logo.png" alt="Postacım Logo" />
          </Logo>
        </HeaderLeft>

        <HeaderRight>
          {user ? (
            <UserInfo>
              <UserName>
                Merhaba,<MobileBreak /> {user.name}
              </UserName>
              <LogoutButton onClick={handleLogout}>Çıkış</LogoutButton>
            </UserInfo>
          ) : (
            <AuthButtons>
              <RegisterButton onClick={() => navigate('/kayit-ol')}>Kayıt Ol</RegisterButton>
              <LoginButton onClick={() => navigate('/giris-yap')}>Giriş Yap</LoginButton>
            </AuthButtons>
          )}
        </HeaderRight>
      </Header>

      <MainContainer>
        <Sidebar $open={sidebarOpen}>
          <SidebarOverlay
            $open={sidebarOpen}
            onClick={() => setSidebarOpen(false)}
          />
          <SidebarContent $open={sidebarOpen} id="sidebar-content">
            <SidebarHeader>
              <SidebarTitle>Menü</SidebarTitle>
              <CloseButton 
                onClick={() => setSidebarOpen(false)}
                aria-label="Menüyü kapat"
              >
                ✕
              </CloseButton>
            </SidebarHeader>

            <NavMenu>
              <NavItem>
                <NavLink to="/" onClick={() => setSidebarOpen(false)}>
                  <NavIcon $color="#2DB47F">
                    <Home size={18} />
                  </NavIcon>
                  Ana Sayfa
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink to="/hizmetler/mektup" onClick={() => setSidebarOpen(false)}>
                  <NavIcon $color="#3B82F6">
                    <PenTool size={18} />
                  </NavIcon>
                  Mektup Yaz
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink to="/cezaevine-mektup" onClick={() => setSidebarOpen(false)}>
                  <NavIcon $color="#00BCD4">
                    <svg viewBox="0 0 24 24" fill="none" width="18" height="18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M4 22H20M5 22V11M19 22V11M12 22V11M9 22V11M15 22V11M2 11L12 2L22 11H2Z" />
                    </svg>
                  </NavIcon>
                  Cezaevine Mektup
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink to="/hizmetler" onClick={() => setSidebarOpen(false)}>
                  <NavIcon $color="#10B981">
                    <LayoutGrid size={18} />
                  </NavIcon>
                  Hizmetler
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink to="/blog" onClick={() => setSidebarOpen(false)}>
                  <NavIcon $color="#F472B6">
                    <BookOpen size={18} />
                  </NavIcon>
                  Blog & Rehber
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink to="/fiyatlandirma" onClick={() => setSidebarOpen(false)}>
                  <NavIcon $color="#F59E0B">
                    <CircleDollarSign size={18} />
                  </NavIcon>
                  Fiyatlandırma
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink to="/kullanici-yorumlari" onClick={() => setSidebarOpen(false)}>
                  <NavIcon $color="#10B981">
                    <MessageSquare size={18} />
                  </NavIcon>
                  Yorumlar
                </NavLink>
              </NavItem>

              {user ? (
                <>
                  <NavItem>
                    <NavLink to="/taslaklar" onClick={() => setSidebarOpen(false)}>
                      <NavIcon $color="#F59E0B">
                        <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
                          <circle cx="12" cy="12" r="10" fill="currentColor" stroke="none" opacity="0.2" />
                          <polyline points="12,6 12,12 16,14" />
                          <circle cx="12" cy="12" r="10" />
                        </svg>
                      </NavIcon>
                      Taslaklar
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink to="/gonderilen-mektuplar" onClick={() => setSidebarOpen(false)}>
                      <NavIcon $color="#10B981">
                        <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
                          <path d="M22 2L11 13" />
                          <path d="M22 2L15 22 11 13 2 9l20-7z" fill="currentColor" stroke="none" opacity="0.25" />
                          <path d="M22 2L15 22 11 13 2 9l20-7z" />
                        </svg>
                      </NavIcon>
                      Gönderilenler
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink to="/davetiyelerim" onClick={() => setSidebarOpen(false)}>
                      <NavIcon $color="#8B5CF6">
                        <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
                          <rect x="3" y="4" width="18" height="18" rx="2" ry="2" fill="currentColor" stroke="none" opacity="0.2" />
                          <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                          <line x1="16" y1="2" x2="16" y2="6" />
                          <line x1="8" y1="2" x2="8" y2="6" />
                          <line x1="3" y1="10" x2="21" y2="10" />
                          <polyline points="9,16 11,18 15,14" />
                        </svg>
                      </NavIcon>
                      Davetiyelerim
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink to="/hesabim" onClick={() => setSidebarOpen(false)}>
                      <NavIcon $color="#EC4899">
                        <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
                          <rect x="2" y="5" width="20" height="14" rx="2" fill="currentColor" stroke="none" opacity="0.2" />
                          <rect x="2" y="5" width="20" height="14" rx="2" />
                          <line x1="2" y1="10" x2="22" y2="10" />
                          <circle cx="7" cy="15" r="1" fill="currentColor" />
                          <circle cx="12" cy="15" r="1" fill="currentColor" />
                        </svg>
                      </NavIcon>
                      Hesabım &amp; Cüzdan
                    </NavLink>
                  </NavItem>

                  <NavItem>
                    <NavLink to="/sikca-sorulan-sorular" onClick={() => setSidebarOpen(false)}>
                      <NavIcon $color="#F59E0B">
                        <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
                          <circle cx="12" cy="12" r="10" />
                          <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
                          <line x1="12" y1="17" x2="12.01" y2="17" />
                        </svg>
                      </NavIcon>
                      SSS
                    </NavLink>
                  </NavItem>

                  <NavItem>
                    <NavLink to="/iletisim" onClick={() => setSidebarOpen(false)}>
                      <NavIcon $color="#8B5CF6">
                        <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
                          <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" fill="currentColor" stroke="none" opacity="0.2" />
                          <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                          <polyline points="22,6 12,13 2,6" />
                        </svg>
                      </NavIcon>
                      İletişim
                    </NavLink>
                  </NavItem>

                  <NavItem>
                    <NavLink to="#" onClick={(e) => { e.preventDefault(); handleLogout(); setSidebarOpen(false); }}>
                      <NavIcon $color="#EF4444">
                        <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
                          <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" fill="currentColor" stroke="none" opacity="0.2" />
                          <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                          <polyline points="16 17 21 12 16 7" />
                          <line x1="21" y1="12" x2="9" y2="12" />
                        </svg>
                      </NavIcon>
                      Çıkış Yap
                    </NavLink>
                  </NavItem>
                </>
              ) : (
                <>
                  <NavItem>
                    <NavLink to="/giris-yap" onClick={() => setSidebarOpen(false)}>
                      <NavIcon $color="#2DB47F">
                        <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
                          <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4" fill="currentColor" stroke="none" opacity="0.2" />
                          <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4" />
                          <polyline points="10 17 15 12 10 7" />
                          <line x1="15" y1="12" x2="3" y2="12" />
                        </svg>
                      </NavIcon>
                      Giriş Yap
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink to="/kayit-ol" onClick={() => setSidebarOpen(false)}>
                      <NavIcon $color="#3B82F6">
                        <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
                          <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                          <circle cx="8.5" cy="7" r="4" />
                          <line x1="20" y1="8" x2="20" y2="14" />
                          <line x1="23" y1="11" x2="17" y2="11" />
                        </svg>
                      </NavIcon>
                      Kayıt Ol
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink to="/sikca-sorulan-sorular" onClick={() => setSidebarOpen(false)}>
                      <NavIcon $color="#F59E0B">
                        <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
                          <circle cx="12" cy="12" r="10" />
                          <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
                          <line x1="12" y1="17" x2="12.01" y2="17" />
                        </svg>
                      </NavIcon>
                      SSS
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink to="/iletisim" onClick={() => setSidebarOpen(false)}>
                      <NavIcon $color="#8B5CF6">
                        <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
                          <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" fill="currentColor" stroke="none" opacity="0.2" />
                          <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                          <polyline points="22,6 12,13 2,6" />
                        </svg>
                      </NavIcon>
                      İletişim
                    </NavLink>
                  </NavItem>
                </>
              )}
            </NavMenu>
          </SidebarContent>
        </Sidebar>

        <Content $sidebarOpen={sidebarOpen}>
          {children}
        </Content>
      </MainContainer>

      {/* Footer */}
      <Footer>
        <FooterContent>
          {!isApp && (
            <FooterColumn className="about-column">
              <FooterTitle 
                $mobileToggle 
                onClick={() => toggleSection('hakkimizda')}
                $expanded={expandedSections.includes('hakkimizda')}
              >
                HAKKIMIZDA
              </FooterTitle>
              <FooterLinkContainer $expanded={expandedSections.includes('hakkimizda')}>
                <AboutContent>
                  <FooterText>
                    Postacim.net, mektup göndermeyi yeniden zahmetsiz ve erişilebilir hale getirmek için kurulmuş dijital bir mektup gönderim platformudur. Kalem, kâğıt ve posta süreçleriyle uğraşmadan; birkaç adımda yazdığınız mektupları sizin adınıza fiziki olarak hazırlayıp alıcısına ulaştırır.
                  </FooterText>
                  {!isApp && <ParamLogo src={paramLogo} alt="Param Logo" />}
                </AboutContent>
              </FooterLinkContainer>
            </FooterColumn>
          )}

          <FooterColumn>
            <FooterTitle 
              $mobileToggle 
              onClick={() => toggleSection('site')}
              $expanded={expandedSections.includes('site')}
            >
              SİTE
            </FooterTitle>
            <FooterLinkContainer $expanded={expandedSections.includes('site')}>
              <FooterLink onClick={() => navigate('/')}>
                <span>Anasayfa</span>
                <ChevronIcon />
              </FooterLink>
              <FooterLink onClick={() => navigate('/cezaevine-mektup')}>
                <span>Cezaevine Mektup</span>
                <ChevronIcon />
              </FooterLink>
              <FooterLink onClick={() => navigate('/hizmetler')}>
                <span>Hizmetler</span>
                <ChevronIcon />
              </FooterLink>
              <FooterLink onClick={() => navigate('/blog')}>
                <span>Blog & Rehber</span>
                <ChevronIcon />
              </FooterLink>
              <FooterLink onClick={() => navigate('/fiyatlandirma')}>
                <span>Fiyatlandırma</span>
                <ChevronIcon />
              </FooterLink>
              <FooterLink onClick={() => navigate('/sikca-sorulan-sorular')}>
                <span>Sıkça Sorulan Sorular</span>
                <ChevronIcon />
              </FooterLink>
              <FooterLink onClick={() => navigate('/kullanici-yorumlari')}>
                <span>Yorumlar</span>
                <ChevronIcon />
              </FooterLink>
            </FooterLinkContainer>
          </FooterColumn>

          <FooterColumn>
            <FooterTitle 
              $mobileToggle 
              onClick={() => toggleSection('kurumsal')}
              $expanded={expandedSections.includes('kurumsal')}
            >
              KURUMSAL
            </FooterTitle>
            <FooterLinkContainer $expanded={expandedSections.includes('kurumsal')}>
              <FooterLink onClick={() => navigate('/iletisim')}>
                <span>İletişim Formu</span>
                <ChevronIcon />
              </FooterLink>
              <FooterLink onClick={() => navigate('/kvkk-aydinlatma')}>
                <span>KVKK Aydınlatma Metni</span>
                <ChevronIcon />
              </FooterLink>
              <FooterLink onClick={() => navigate('/gizlilik-politikasi')}>
                <span>Gizlilik Politikası</span>
                <ChevronIcon />
              </FooterLink>
              <FooterLink onClick={() => navigate('/kullanim-kosullari')}>
                <span>Üyelik Sözleşmesi</span>
                <ChevronIcon />
              </FooterLink>
              <FooterLink onClick={() => navigate('/mesafeli-satis-sozlesmesi')}>
                <span>Mesafeli Satış Sözleşmesi</span>
                <ChevronIcon />
              </FooterLink>
            </FooterLinkContainer>
          </FooterColumn>

          <FooterColumn>
            <FooterTitle 
              $mobileToggle 
              onClick={() => toggleSection('uyelik')}
              $expanded={expandedSections.includes('uyelik')}
            >
              ÜYELİK
            </FooterTitle>
            <FooterLinkContainer $expanded={expandedSections.includes('uyelik')}>
              {user ? (
                <>
                  <FooterLink onClick={() => navigate('/hizmetler/mektup')}>
                    <span>Mektup Yaz</span>
                    <ChevronIcon />
                  </FooterLink>
                  <FooterLink onClick={() => navigate('/taslaklar')}>
                    <span>Gönderilmeyenler</span>
                    <ChevronIcon />
                  </FooterLink>
                  <FooterLink onClick={() => navigate('/gonderilen-mektuplar')}>
                    <span>Gönderilenler</span>
                    <ChevronIcon />
                  </FooterLink>
                  <FooterLink onClick={() => navigate('/hesabim')}>
                    <span>Hesabım & Cüzdan</span>
                    <ChevronIcon />
                  </FooterLink>
                  <FooterLink onClick={handleLogout}>
                    <span>Çıkış Yap</span>
                    <ChevronIcon />
                  </FooterLink>
                </>
              ) : (
                <>
                  <FooterLink onClick={() => navigate('/giris-yap')}>
                    <span>Giriş Yap</span>
                    <ChevronIcon />
                  </FooterLink>
                  <FooterLink onClick={() => navigate('/kayit-ol')}>
                    <span>Kayıt Ol</span>
                    <ChevronIcon />
                  </FooterLink>
                </>
              )}
            </FooterLinkContainer>
          </FooterColumn>

          <FooterColumn>
            <FooterTitle 
              $mobileToggle 
              onClick={() => toggleSection('iletisim')}
              $expanded={expandedSections.includes('iletisim')}
            >
              İLETİŞİM
            </FooterTitle>
            <FooterLinkContainer $expanded={expandedSections.includes('iletisim')}>
              <FooterLink onClick={() => window.open('mailto:iletisim@postacim.net')}>
                <span>iletisim@postacim.net</span>
                <ChevronIcon />
              </FooterLink>
              <FooterLink onClick={() => window.open('tel:+908505541031')}>
                <span>+90 (850) 554 10 31</span>
                <ChevronIcon />
              </FooterLink>
              <SocialIcons>
                <SocialIcon 
                  href="https://www.facebook.com/profile.php?id=61579026836282" 
                  target="_blank"
                  aria-label="Postacım Facebook sayfasını ziyaret edin"
                >
                  {getSocialIconSvg('facebook')}
                </SocialIcon>
                <SocialIcon 
                  href="https://x.com/Postacim_net" 
                  target="_blank"
                  aria-label="Postacım X (Twitter) sayfasını ziyaret edin"
                >
                  {getSocialIconSvg('twitter')}
                </SocialIcon>
                <SocialIcon 
                  href="https://www.instagram.com/postacim.app/" 
                  target="_blank"
                  aria-label="Postacım Instagram sayfasını ziyaret edin"
                >
                  {getSocialIconSvg('instagram')}
                </SocialIcon>
                <SocialIcon 
                  href="https://www.tiktok.com/@postacim.app" 
                  target="_blank"
                  aria-label="Postacım TikTok sayfasını ziyaret edin"
                >
                  {getSocialIconSvg('tiktok')}
                </SocialIcon>
              </SocialIcons>
              {!isApp && (
                <StoreBadges>
                  <StoreLink href="https://apps.apple.com/tr/app/postac%C4%B1m/id6760547392" target="_blank">
                    <StoreImage src={appStoreLogo} alt="App Store" />
                  </StoreLink>
                  <StoreLink href="https://play.google.com/store/apps/details?id=net.postacim.app&pli=1" target="_blank">
                    <StoreImage src={googlePlayLogo} alt="Google Play" />
                  </StoreLink>
                </StoreBadges>
              )}
              <FooterCardImg src={cardLogo} alt="Ödeme Seçenekleri" />
            </FooterLinkContainer>
          </FooterColumn>
        </FooterContent>
      </Footer>
    </Container>
  );
};

// Styled Components
const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: #000;
`;

const Header = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 2rem;
  padding-top: calc(1.5rem + env(safe-area-inset-top, 20px));
  background-color: #000;
  border-bottom: 1px solid #333;
  position: sticky;
  top: 0;
  z-index: 1000;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
`;

const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

const MenuButton = styled.button`
  background: none;
  border: none;
  color: #fff;
  font-size: 1.5rem;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  
  &:hover {
    background-color: #333;
  }

  @media (max-width: 768px) {
    font-size: 2rem;
    padding: 0.75rem;
    margin-left: -0.5rem;
  }
`;

const Logo = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  transition: all 0.3s ease;
  border-radius: 8px;
  padding: 0.25rem;
  
  &:hover {
    transform: translateY(-2px);
    opacity: 0.9;
    background-color: rgba(45, 180, 127, 0.1);
  }
  
  &:active {
    transform: translateY(0px);
  }

  @media (max-width: 768px) {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    
    &:hover {
      transform: translateX(-50%) translateY(-2px);
    }
  }
`;

const LogoImage = styled.img`
  width: 160px;
  height: 60px;
  border-radius: 12px;
  object-fit: contain;
`;


const HeaderRight = styled.div`
  display: flex;
  align-items: center;
`;

const UserInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

const UserName = styled.span`
  color: #fff;
  font-size: 0.9rem;
  
  @media (max-width: 768px) {
    font-size: 0.85rem;
    line-height: 1.3;
  }
`;

const MobileBreak = styled.br`
  display: none;
  
  @media (max-width: 768px) {
    display: block;
  }
`;

const LogoutButton = styled.button`
  background-color: #ff4444;
  color: #fff;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9rem;
  
  &:hover {
    background-color: #cc3333;
  }
  
  @media (max-width: 768px) {
    display: none;
  }
`;

const AuthButtons = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  
  @media (max-width: 768px) {
    display: none;
  }
`;

const LoginButton = styled.button`
  background-color: #2DB47F;
  color: #fff;
  border: none;
  padding: 0.6rem 1.2rem;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 600;
  transition: all 0.2s ease;
  
  &:hover {
    background-color: #25a068;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(45, 180, 127, 0.3);
  }
`;

const RegisterButton = styled.button`
  background-color: transparent;
  color: #2DB47F;
  border: 2px solid #2DB47F;
  padding: 0.6rem 1.2rem;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 600;
  transition: all 0.2s ease;
  
  &:hover {
    background-color: #2DB47F;
    color: #fff;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(45, 180, 127, 0.3);
  }
`;

const MainContainer = styled.div`
  display: flex;
  flex: 1;
  position: relative;
`;

const Sidebar = styled.aside<{ $open: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  z-index: 1001;
  transition: transform 0.3s ease;
  transform: ${props => props.$open ? 'translateX(0)' : 'translateX(-100%)'};
`;

const SidebarOverlay = styled.div<{ $open: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: ${props => props.$open ? 'block' : 'none'};
`;

const SidebarContent = styled.div<{ $open: boolean }>`
  width: 280px;
  height: 100vh;
  background-color: #111;
  border-right: 1px solid #333;
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 1002;
  overflow-y: auto; /* Kendi içindeki scroll desteği */
  -webkit-overflow-scrolling: touch; /* iOS pürüzsüz kaydırma */
  overscroll-behavior: contain;
  display: flex;
  flex-direction: column;
  
  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background: #333;
    border-radius: 10px;
  }
`;

const SidebarHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.25rem 1.5rem;
  /* iOS Ada/Çentik Desteği - Daha geniş padding ve fallback */
  padding-top: calc(max(3.5rem, env(safe-area-inset-top, 54px)) + 1rem) !important; 
  border-bottom: 1px solid #333;
  background-color: #1a1a1a;
`;

const SidebarTitle = styled.h2`
  color: #fff;
  margin: 0;
  font-size: 1.2rem;
`;

const CloseButton = styled.button`
  background: #333;
  border: none;
  color: #fff;
  font-size: 1.5rem;
  cursor: pointer;
  padding: 0.6rem;
  border-radius: 50%;
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  
  &:hover {
    background-color: #444;
    transform: scale(1.1);
  }

  &:active {
    transform: scale(0.9);
  }
`;

const NavMenu = styled.nav`
  flex: 1;
  padding: 1rem 0;
`;

const NavItem = styled.div`
  margin-bottom: 0.5rem;
`;

const NavLink = styled(Link)`
  display: flex;
  align-items: center;
  color: #fff;
  text-decoration: none;
  padding: 1.25rem 2rem;
  font-size: 1.1rem;
  border-left: 4px solid transparent;
  transition: all 0.2s;
  text-align: left;
  gap: 1rem;
  width: 100%;
  box-sizing: border-box;
  
  &:hover {
    background-color: #1a1a1a;
    border-left-color: #2DB47F;
    padding-left: 2.25rem;
  }
  
  &:active {
    background-color: #222;
  }
  
  &.active {
    background-color: rgba(45, 180, 127, 0.15);
    border-left-color: #2DB47F;
    color: #2DB47F;
  }
`;

const NavIcon = styled.div<{ $color?: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 10px;
  flex-shrink: 0;
  background-color: ${props => props.$color ? `${props.$color}22` : 'rgba(255,255,255,0.08)'};
  color: ${props => props.$color || '#fff'};
  transition: all 0.2s;

  svg {
    width: 18px;
    height: 18px;
    flex-shrink: 0;
  }

  ${NavLink}:hover & {
    background-color: ${props => props.$color ? `${props.$color}33` : 'rgba(255,255,255,0.15)'};
    transform: scale(1.1);
  }
`;

const Content = styled.main<{ $sidebarOpen: boolean }>`
  flex: 1;
  padding: 0;
  transition: margin-left 0.3s ease;
  overflow-x: hidden;
`;

// Footer Styled Components
const Footer = styled.footer`
  background-color: #111;
  border-top: 1px solid #333;
  padding: 2rem 0;
  padding-bottom: calc(2rem + env(safe-area-inset-bottom));
  margin-top: 0;
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
  display: grid;
  grid-template-columns: 1.5fr 1fr 1.35fr 1fr 1fr;
  gap: 2rem;
  
  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    padding: 0 1rem;
    gap: 1.5rem;
  }
  
  @media (max-width: 480px) {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
`;

const FooterColumn = styled.div`
  margin-bottom: 2rem;
  text-align: left;
`;

const FooterText = styled.p`
  font-size: 0.9rem;
  color: #ccc;
  line-height: 1.4;
  margin-bottom: 0.5rem;
`;

const FooterTitle = styled.h2<{ $mobileToggle?: boolean, $expanded?: boolean }>`
  font-size: 1rem;
  font-weight: bold;
  color: #2DB47F;
  margin-bottom: 1rem;
  text-align: left;
  
  @media (max-width: 768px) {
    background-color: #1a1a1a;
    padding: 1.25rem 1.5rem;
    margin: 0;
    border-bottom: 1px solid #333;
    cursor: pointer;
    font-size: 1.1rem;
    display: flex;
    justify-content: space-between;
    align-items: center;

    &::after {
      content: '▲';
      font-size: 0.8rem;
      opacity: 0.5;
      transition: transform 0.3s;
      transform: ${props => props.$expanded ? 'rotate(0deg)' : 'rotate(180deg)'};
    }
  }
`;

const FooterLinkContainer = styled.div<{ $expanded?: boolean }>`
  @media (max-width: 768px) {
    background-color: #111;
    max-height: ${props => props.$expanded ? '1000px' : '0'};
    overflow: hidden;
    transition: max-height 0.3s ease-in-out;
  }
`;

const AboutContent = styled.div`
  @media (max-width: 768px) {
    padding: 1rem 1.5rem;
    padding-top: 0.5rem;
  }
`;

const FooterLink = styled.button`
  background: none;
  border: none;
  color: #ccc;
  font-size: 0.9rem;
  cursor: pointer;
  padding: 0;
  margin-bottom: 0.8rem;
  text-align: left;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  transition: all 0.2s;
  
  &:hover {
    color: #2DB47F;
    transform: translateX(5px);
  }

  @media (max-width: 768px) {
    padding: 1.25rem 1.5rem;
    margin: 0;
    border-bottom: 1px solid #222;
    background-color: #111;
    font-size: 1rem;

    &:active {
      background-color: #1a1a1a;
    }

    &:last-child {
      border-bottom: none;
    }
  }
`;

const ChevronIcon = () => (
  <svg 
    width="16" 
    height="16" 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
    style={{ opacity: 0.3, display: 'none' }}
    className="chevron-mobile"
  >
    <polyline points="9 18 15 12 9 6"></polyline>
    <style>{`
      @media (max-width: 768px) {
        .chevron-mobile { display: block !important; }
      }
    `}</style>
  </svg>
);

const SocialIcons = styled.div`
  display: flex;
  gap: 0.75rem;
  margin-top: 1rem;
`;

const SocialIcon = styled.a`
  width: 32px;
  height: 32px;
  border-radius: 16px;
  background-color: #006645;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  text-decoration: none;
  transition: all 0.2s ease;
  
  &:hover {
    background-color: #2DB47F;
    transform: translateY(-2px);
  }
`;

const StoreBadges = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  margin-top: 1.5rem;
`;

const StoreLink = styled.a`
  display: inline-block;
  transition: transform 0.2s ease, opacity 0.2s ease;
  
  &:hover {
    transform: translateY(-2px);
    opacity: 0.9;
  }
  
  &:active {
    transform: translateY(0);
  }
`;

const StoreImage = styled.img`
  height: 40px;
  width: 135px;
  object-fit: contain;
  display: block;
`;

const FooterCardImg = styled.img`
  height: 30px;
  width: auto;
  margin-top: 2rem;
  opacity: 0.8;
  display: block;
  margin-left: 0;
  margin-right: auto;
  object-fit: contain;
`;

const ParamLogo = styled.img`
  height: auto;
  max-width: 180px;
  width: 100%;
  margin-top: 1rem;
  display: block;
  object-fit: contain;
  border-radius: 4px;

  @media (max-width: 768px) {
    display: none;
  }
`;

export default Layout;

